import React from "react";
import { useHistory } from "react-router";
import HeaderTopic from "../../partials/HeaderTopic";
import styles from "./Term.module.css";

function Term() {
  const history = useHistory();
  const handleClick = () => {
    history.push("/signup/1");
  };
  return (
    <div className={styles.term}>
      <HeaderTopic topic="תקנון שימוש" />
      <h2>אפליקציית "ליגת החלוץ" – מדיניות פרטיות</h2>
      <ol>
        <li>
          מדיניות זו מובאת בפני המשתמשים באתר "ליגת החלוץ", ליגת כדורגל המופעלת
          על ידי ע"ר יסודות לצמיחה דרור (להלן: <b>"העמותה"</b>) במהלך החודשים
          יולי-אוגוסט 2021, בה ישתתפו בני נוער מערים שונות ברחבי הארץ.
        </li>
        <li>
          אתר האינטרנט של "ליגת החלוץ" (בכתובת:https:
          נועד לאפשר לך להירשם לפעילויות המתקיימות במסגרת "ליגת החלוץ", לעקוב
          אחרי עדכונים ולקבל מידע רלוונטי.
        </li>
        <li>
          בעת ההרשמה לאתר האינטרנט שלנו ויצירת פרופיל, תתבקש/י, לפי הצורך, להזין
          את שמך המלא, מספר הטלפון, עיר, כיתה, בית ספר, תמונה או פרטים אחרים
          שיעזרו לך בחוויה שלך.
        </li>
        <li>
          בנוסף במהלך השימוש באתר האינטרנט יישמר וייאגר מידע ביחס למשתתפים
          ב"ליגת החלוץ" והקבוצות השונות, כגון: מספר גולים, בישולים, ניצחונות,
          הפסדים, תיקו, ניקוד, כרטיסים ירוקים, שיהיה חשוף לכל המשתתפים
          באפליקציה.
        </li>
        <li>
          אנו עשויים להשתמש במידע שאנו אוספים ממך בעת ההרשמה לאפליקציה/אתר
          האינטרנט ובמידע נוסף שייאגר במהלך הפעילות וההשתתפות שלך ושל קבוצתך
          ב"ליגת החלוץ", בדרכים הבאות:
          <ul>
            <li>
              מירת המידע שנמסר בעת ההרשמה לאתר, ובכלל כך פרטים אישיים ותמונה;
            </li>
            <li>
              יהול מידע, פילוח וסטטיסטיקה של הנרשמים והמשתמשים באתר, וכן של
              הפעילות שלהם במהלך ב"ליגת החלוץ".
            </li>
          </ul>
        </li>
        <li>
          אנחנו עשויים למסור את המידע שנשמר או חלקו, למזמיני הפעילות (כגון: רשות
          מקומית, חברה עירונית, מתנ"ס, מרכזים קהילתיים וכיו"ב), או לעמותות
          קשורות במידה סבירה, או לפי מה שנדרש מאיתנו על פי חוק.
        </li>
        <li>
          אנחנו עשויים למסור את המידע שנשמר לכל אחד מהעובדים, המנהלים, היועצים
          המקצועיים, הספקים, במידה סבירה, או לפי מה שנדרש מאיתנו על פי חוק.
        </li>
        <li>
          אנחנו ננקוט משנה זהירות ארגוני וטכני סביר על מנת למנוע את האבדן,
          השימוש לרעה, או השינוי של הפרטים האישיים שלכם.
        </li>
        <li>
          אנחנו נאחסן את הפרטים האישיים שמסרתם לנו בשרתים מאובטחים. הנתונים
          שישמרו אודות הפעילות ב"ליגת החלוץ" והמשחקים שהתקיימו במסגרתה יימחקו
          לאחר תום תקופת הפעילות של "ליגת החלוץ".
        </li>
        <li>
          אתם מכירים בכך שהשידור של מידע על פני האינטרנט אינו מאובטח מעצם היותו,
          ואנחנו לא יכולים להבטיח שנתונים שנשלחים דרך האינטרנט יהיו מאובטחים.
        </li>
        <li>
          אתם אחראים על שמירת הסיסמא בה אתם משתמשים לקבלת גישה לאתר שלנו חסויה;
          אנחנו לא נבקש מכם את הסיסמא שלכם (למעט בזמן ההתחברות).
        </li>
        <li>
          שימוש באתר האינטרנט מהווה הסכמה מצדך להוראות ולתנאים אלה והתחייבות
          לפעול בהתאם להם.
        </li>
        <div className={styles.mid}>
          <span className="btnLarge" onClick={handleClick}>
            חזרה להרשמה
          </span>
        </div>
      </ol>
    </div>
  );
}

export default Term;
